import PostGrid from "./postGrid"

export default PostGrid
